import {
  Component,
  inject,
  ChangeDetectionStrategy,
  computed,
} from '@angular/core';
import { ToastService } from '../toast.service';
import { ToastItemComponent } from '../toast-item/toast-item.component';
import type { ToastItem, ToastPosition } from '../toast.models';

const POSITIONS: ToastPosition[] = [
  'top-right', 'top-center', 'top-left',
  'bottom-right', 'bottom-center', 'bottom-left',
];

@Component({
  selector: 'toast-container',
  standalone: true,
  imports: [ToastItemComponent],
  templateUrl: './toast-container.component.html',
  styleUrl: './toast-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastContainerComponent {
  private readonly toastService = inject(ToastService);

  readonly positions = POSITIONS;

  readonly groupedToasts = computed(() => {
    const map = new Map<ToastPosition, ToastItem[]>();
    POSITIONS.forEach(p => map.set(p, []));
    this.toastService.toasts().forEach(t => map.get(t.position)!.push(t));
    return map;
  });

  onDismissed(id: string): void {
    this.toastService.dismiss(id);
  }
}
